const TOKENS_PER_AI_CREDIT = 1e4;
function tokensToAiCredits(totalTokens, _featureKey) {
  return totalTokens / TOKENS_PER_AI_CREDIT;
}
const AiUsageOperationKeyPrefix = {
  Signals: "signals:",
  ResearchAgentTurn: "research_agent:turn:",
  ResearchAgentGradingFinding: "research_agent:grading_finding:",
  ResearchAgentTeammateFinding: "research_agent:teammate_finding:",
  ScheduledAgentsOrchestration: "scheduled_agents:orchestration:",
  ScheduledAgentsSubagent: "scheduled_agents:subagent:",
  McpToolCall: "mcp_tool_call:"
};
function buildAiUsageOperationKey(prefix, ...operationIds) {
  return `${prefix}${operationIds.join(":")}`;
}
const aiUsageFeatureUnits = {
  signals: {
    featureUnitNoun: { singular: "match", plural: "matches" }
  },
  research_agent: {
    featureUnitNoun: { singular: "question", plural: "questions" }
  },
  scheduled_agents: {
    featureUnitNoun: { singular: "run", plural: "runs" }
  },
  mcp_tool_call: {
    featureUnitNoun: { singular: "tool call", plural: "tool calls" }
  }
};
export {
  AiUsageOperationKeyPrefix,
  aiUsageFeatureUnits,
  buildAiUsageOperationKey,
  tokensToAiCredits
};
//# sourceMappingURL=aiCredits.js.map
